window.centaurPiano = window.centaurPiano || {
	redirectTo: false,
	loginReload: 'enabled',
	ajaxUrl: false,
	checkSync: false,
	logged_in: false,
	reset_token: false
};

window.centaurPiano.controls = (function() {
	var pianoLoginEvent     = new Event( 'pianoLoginSuccess' ),
		overlay, // Body of the overlay
		gotoRedirect        = function( redirectTo ) {
			if ( centaurPiano.loginReload !== 'no' ) {
				redirectTo = typeof redirectTo === 'undefined' ? centaurPiano.redirectTo : redirectTo;
				if ( window.location.href === redirectTo ) {
					window.location.reload();
				}
				else {
					window.location.replace( redirectTo );
				}
			}
		},
		ajaxEvent           = function( args ) {
			pianoLoaded.then( () => {
				// You're not logged in to either WordPress or Piano, so I don't know what you're even trying to do.
				if ( !window.tp.user.isUserValid() && !window.centaurPiano.logged_in ) {
					console.error( 'Nothing to do!', args );
					return false;
				}

				let options = {
					method: 'POST',
					headers: { 'Accept': 'application/json' },
					body: new URLSearchParams()
				};

				options.body.append( 'nonce', window.centaurPiano.nonce );
				options.body.append( 'uid', typeof args.uid === 'undefined' ? window.tp.user.getProvider().getUser().uid : args.uid );
				options.body.append( 'token', typeof args.token === 'undefined' ? window.tp.user.getProvider().getToken() : args.token );
				options.body.append( 'action', typeof args.action === 'undefined' ? (!window.centaurPiano.logged_in ? 'piano_login' : 'piano_profile_update') : args.action );

				fetch( window.centaurPiano.ajaxUrl, options )
					.then( response => {
						return response.json();
					} )
					.then( response => {
						// Something isn't quite right
						if ( response.status !== 200 ) {
							throw new Error( response.message ? response.message : 'Unknown error' );
						}
						// If we've got something to do with the return we'll pass it on.
						if ( typeof args.success === 'function' ) {
							args.success( response );
						}
					} )
					.catch( typeof args.failure === 'function' ? args.failure : console.error );
			} ).catch( console.error );
		},
		getAuthToken        = async function() {
			let token = new Promise( function( resolve, reject ) {
				if ( window.tp.pianoId.isUserValid() ) {
					resolve( window.tp.pianoId.getToken() );
				}
				else if ( window.centaurPiano.logged_in ) {
					ajaxEvent(
						{
							action: 'piano_relog',
							token: false,
							uid: false,
							success: function( response ) {
								if ( response && response.user_token ) {
									resolve( response.user_token );
								}
								else {
									reject( 'Authentication token invalid', response );
								}
							},
							failure: function( e ) {
								reject( e.message ? e.message : 'Error collecting authentication token', e );
							}
						} );
				}
				else {
					reject( 'No token available' );
				}
			} );

			return await token;
		},
		wait                = delay => new Promise( resolve => setTimeout( resolve, delay ) ),
		retryFunction       = ( func, retries, delay ) => new Promise( ( resolve, reject ) => {
			return func()
				.then( resolve )
				.catch( ( reason ) => {
					if ( retries > 1 ) {
						return wait( delay )
							.then( retryFunction.bind( null, func, retries - 1, delay ) )
							.then( resolve )
							.catch( reject );
					}
					return reject( reason );
				} );
		} ),
		loginCompleted      = false, // Flag set to true by loginComplete event
		// Keep watching until both the loginSuccess event and isUserValid return true or we time out.
		loginComplete       = async function() {
			const pause   = 100,
				  timeOut = 30000;
			let tries     = 0;

			return retryFunction( () => {
				if ( !window.tp.user.isUserValid() ) {
					console.debug( 'Login failed', ++tries );
					return Promise.resolve( { msg: 'Login failed', state: false } );
				}
				else if ( loginCompleted ) {
					return Promise.resolve( { msg: 'Login by token process completed', state: true } );
				}
				else {
					// Still waiting so we'll try again in a moment
					console.debug( 'Waiting for login process to complete', ++tries );
					return Promise.reject();
				}

			}, (timeOut / pause), pause );
		},
		authTokenLogin      = async function( token ) {
			console.debug( 'Starting Piano login' );
			window.tp.pianoId.loginByToken( token );

			// Wait for the login to complete
			return await loginComplete().then( response => {
				return response.state ? Promise.resolve( response.msg ) : Promise.reject( response.msg );
			} );
		},
		pianoIdConfig       = {
			loginSuccess: function() {
				// Tell the world that we have succeeded
				console.debug( 'Piano: Login success.' );

				// Disable the bomb
				loginCompleted = true;

				// Logged in to both WordPress and Piano so this is the end for us.
				if ( window.centaurPiano.logged_in ) {
					console.debug( 'Piano: Login complete event triggering.' );
					window.dispatchEvent( pianoLoginEvent );
				}
				// We need to try and log back in to WordPress using the Piano details
				else if ( window.tp.user.isUserValid() ) {
					console.debug( 'Piano: Not logged into service provider.' );
					ajaxEvent(
						{
							action: 'piano_login',
							success: () => {
								console.debug( 'Piano: Service provider logged in.' );
								gotoRedirect();
							},
							failure: e => {
								console.debug( 'Piano: Failed to log in to service provider.' );
								if ( confirm( e.message + "\n\nDo you want to reload the page and try again?" ) === true ) {
									window.tp.user.logout();
									window.location.reload();
								}
							}
						} );
				}
			},
			loginFailed: ( why ) => {
				console.debug( 'Piano: Login failed', why );
			},
			loginRequired: function() {
				console.debug( 'Piano: Login required.' );
				showLogin();
			},
			loggedOut: function() {
				console.debug( 'Piano: Logged out.' );

				// We've been logged out of Piano we may need to exit WP
				if ( window.centaurPiano.logged_in ) {
					ajaxEvent( { action: 'piano_logout', token: false, uid: false, success: () => gotoRedirect } );
				}
			},
			profileUpdate: function() {
				console.debug( 'Piano: Profile update.' );
				ajaxEvent( { action: 'piano_profile_update' } );
			},
			onShow: function() {
				var loading = document.querySelectorAll( '.pianoLoading' ), i;

				for ( i = 0; i < loading.length; i++ ) {
					loading[ i ].classList.remove( 'pianoLoading' );
				}
			}
		},
		overlayStyle        = {
			position: 'fixed',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			width: '100vw',
			height: '100vh',
			overflow: 'hidden auto',
			zIndex: 100022,
			backgroundColor: 'rgba( 0, 0, 0, 0.75 )',
			backgroundImage: 'url("data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9y' +
							 'Zy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDY0MCA2NDAiPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik02MzkuOTk5IDQ' +
							 '4LjA0OGwtMjc0LjEyNiAyNzYuOTM5IDI2Ny42MDQgMjcwLjM1My00NC4xNzkgNDQuNjU5LTI2Ny42MDQtMjcwLj' +
							 'M1My0yNjMuNzA0IDI2Ni4zOS00My42NjgtNDQuMDg0IDI2My43MDQtMjY2LjQyMi0yNzguMDI2LTI4MC44NzEgN' +
							 'DQuMjEyLTQ0LjY1OSAyNzguMDI2IDI4MC44NzEgMjc0LjA5NC0yNzYuOTA3IDQzLjY2OCA0NC4wODR6IiAvPjwv' +
							 'c3ZnPgo=")',
			backgroundSize: '20px 20px',
			backgroundRepeat: 'no-repeat',
			backgroundPosition: '95% 30px',
			cursor: 'pointer',
			padding: '75px 20px 20px'
		},
		containerStyle      = {
			maxWidth: window.centaurPiano.width + 'px',
			minWidth: '280px',
			width: '100%',
			padding: '10px',
			borderRadius: '10px',
			backgroundColor: '#ffffff',
			border: 'solid 10px #efefef',
			margin: '0 auto',
			cursor: 'default'
		},
		/**
		 * Create a generic modal, the modal will close if the return from the callback is false
		 *
		 * @param id
		 * @param callback
		 * @param loader
		 */
		createModal         = function( id, callback, loader ) {
			var container = document.createElement( 'div' ), // The div that'll house the profile page
				target    = document.createElement( 'div' ); // The div that'll house the profile page

			// Give the account overlay a unique ID
			target.setAttribute( 'id', id.toString().replace( /^#/, '' ) );

			// Show the loading interface.
			if ( !!loader ) {
				target.classList.add( 'pianoLoading' );
			}

			// Remove the any previous Overlay objects
			if ( typeof overlay !== 'undefined' ) {
				overlay.remove();
			}

			// Create the overlay object
			overlay = document.createElement( 'div' );

			// Click the background should close things
			overlay.addEventListener( 'click', function( e ) {
				if ( e.target === overlay ) {
					e.stopPropagation();
					overlay.remove();
				}
			} );

			// Glue everything together.
			container.appendChild( target );
			overlay.appendChild( container );

			// Style to elements
			Object.assign( overlay.style, overlayStyle );
			Object.assign( container.style, containerStyle );

			// Stick our elements at the end of the body tag
			document.body.appendChild( overlay );

			// Load up the profile page
			if ( (typeof callback === 'function' && callback( target, overlay )) === false ) {
				// The callback returned false so we should remove it.
				overlay.remove();
			}
		},
		/**
		 * Is the element visible on the page
		 *
		 * @param elm
		 * @returns {boolean}
		 */
		checkVisible        = function( elm ) {
			var rect       = elm.getBoundingClientRect();
			var viewHeight = Math.max( document.documentElement.clientHeight, window.innerHeight );
			return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
		},
		/**
		 *
		 * @param query A Query selector or a Node
		 * @param screen
		 * @param args
		 *
		 * @returns {boolean}
		 */
		show                = function( query, screen, args ) {
			var target = typeof query === 'string' ? document.querySelector( query ) : query;

			// Make sure the node we're using has an ID or set one
			target.id || (target.id = '_' + Math.random().toString( 36 ).substr( 2, 9 ));

			switch ( screen ) {
				// PianoID screens
				case 'login':
				case 'register':
				case 'new_password':
				case 'restore':
					if ( window.tp.user.isUserValid() ) {
						console.debug( 'Piano: failed to show ' + screen + ' screen.' );
						return false;
					}

					// Throw out the loading class
					if ( typeof target.classList !== 'undefined' ) {
						target.classList.add( 'pianoLoading' );
					}

					window.tp.pianoId.show( { displayMode: 'inline', containerSelector: '#' + target.id, screen: screen } );

					return true;

				// MyAccount screen
				case 'myaccount':
					window.tp.myaccount.show(
						{
							displayMode: 'inline',
							containerSelector: '#' + target.id,
							loginRequired: function() {
								showLogin();
							}
						} );

					return true;

				// Offers screen
				case 'offer':
					if ( typeof args.offer === 'undefined' || args.offer === '' ) {
						return false;
					}

					window.tp.offer.show(
						{
							displayMode: 'inline',
							containerSelector: '#' + target.id,
							offerId: args.offer,
							templateId: args.template,
							termIds: args.terms
						} );

					return true;

				// I couldn't figure out what you were talking about
				default:
					console.error( 'No screen can be shown for: ', screen );
					return false;
			}
		},

		showMyAccount       = function() {
			pianoLoaded.then( function() {
				createModal( 'tinypassMyAccount', function( node ) {
					return show( node, 'myaccount', {} );
				} );
			} ).catch( console.error );
		},
		showRegistration    = function() {
			pianoLoaded.then( function() {
				createModal( 'tinypassRegister', function( node ) {
					return show( node, 'register', {} );
				}, true );
			} ).catch( console.error );
		},
		showPasswordRecover = function() {
			pianoLoaded.then( function() {
				createModal( 'tinypassRegister', function( node ) {
					return show( node, window.centaurPiano.reset_token.length > 0 ? 'new_password' : 'restore', {} );
				}, true );
			} ).catch( console.error );
		},
		showLogin           = function() {
			pianoLoaded.then( function() {
				createModal( 'tinypassRegister', function( node ) {
					return show( node, 'login', {} );
				}, true );
			} ).catch( console.error );
		},
		showOffer           = function( offer, template, terms ) {
			pianoLoaded.then( function() {
				createModal( 'tinypassRegister', function( node ) {
					return show( node, 'offer', { offer: offer, templateId: template, terms: terms } );
				} );
			} ).catch( console.error );
		},
		scrollWatch         = {
			running: false,
			elements: [],
			watch: function() {
				for ( var i in scrollWatch.elements ) {
					if ( !scrollWatch.elements.hasOwnProperty( i ) ) {
						continue;
					}

					// The item is on screen so trigger it
					if ( checkVisible( scrollWatch.elements[ i ] ) ) {
						var screen = typeof scrollWatch.elements[ i ].dataset.pianoScreen !== 'undefined' && scrollWatch.elements[ i ].dataset.pianoScreen,
							args   = typeof scrollWatch.elements[ i ].dataset.pianoArgs !== 'undefined' && JSON.parse( scrollWatch.elements[ i ].dataset.pianoArgs );

						// Create a pop up once the element scrolls into view
						createModal( 'tinypass' + screen, (function( s, a ) {
							return function( node ) {
								return show( node, s, a );
							};
						}( screen, args )) );

						// Remove it from the array once triggered
						scrollWatch.elements.splice( i, 1 );
					}
				}

				// If the elements array is now empty we should stop the watch
				if ( scrollWatch.elements.length === 0 ) {
					scrollWatch.running = false;
					window.removeEventListener( 'scroll', scrollWatch.watch );
				}
			},
			addElement: function( element ) {
				scrollWatch.elements.push( element );

				if ( !scrollWatch.running ) {
					window.addEventListener( 'scroll', scrollWatch.watch );
				}
			}
		},
		getRandomString     = function( length ) {
			var s         = 'abcdefghijklmnopqrstuvwxyz',
				randgen   = '',
				num_parts = length / 4, i;

			for ( i = 0; i < num_parts; i++ ) {
				randgen += Array( 4 ).join().split( ',' ).map( function() {
					return s.charAt( Math.floor( Math.random() * s.length ) );
				} ).join( '' );
				if ( i < num_parts - 1 ) {
					randgen += '-';
				}
			}
			return randgen;
		},
		setLoginFailureURL  = function() {
			let urlParams = new URLSearchParams( window.location.search );
			if ( !urlParams.get( 'failed-login' ) ) {
				urlParams.set( 'failed-login', 1 );
				window.location.search = urlParams;
			}
			else {
				window.location.reload();
			}
		};

	/**
	 * Once Piano has completed loading we'll set everything else up.
	 */
	pianoLoaded.then( () => {
		var elements = document.querySelectorAll( '[data-piano-screen]' ), i;

		// Set up pianoID
		window.tp.pianoId.init( pianoIdConfig );

		// Do we need to run a profile update check?
		if ( !!window.centaurPiano.checkSync && window.tp.user.isUserValid() ) {
			ajaxEvent( { action: 'piano_profile_update' } );
		}

		// Somehow we're not quite logged in completely!
		if ( window.centaurPiano.logged_in && !window.tp.user.isUserValid() ) {
			console.debug( 'Login disconnection' );

			getAuthToken()
				.then( ( token ) => retryFunction( () => {
					console.debug( 'Trying to login with token' );
					return authTokenLogin( token );
				}, 5, 2000 ) )
				.then( console.debug )
				.catch( ( msg ) => {
					console.error( 'Piano: Authentication token login failure.', msg );
					// Force logging out of WordPress
					ajaxEvent( { action: 'piano_logout', token: false, uid: false, success: setLoginFailureURL } );
				} );
		}

		// Listen for the escape key and close any open modal
		document.addEventListener( 'keyup', function( e ) {
			if ( e.key === 'Escape' && typeof overlay !== 'undefined' ) {
				e.stopPropagation();
				overlay.remove();
			}
		} );

		// Look for any objects inline that need to be replaced with piano elements
		for ( i = 0; i < elements.length; i++ ) {
			var element = elements[ i ],
				args    = typeof element.dataset.pianoArgs !== 'undefined' ? JSON.parse( element.dataset.pianoArgs ) : {},
				type    = typeof element.dataset.pianoType !== 'undefined' ? element.dataset.pianoType : 'inline'; // Assume inline if not set

			// The screen hasn't been defined so we should run away
			if ( typeof element.dataset.pianoScreen === 'undefined' ) {
				continue;
			}

			// If there's no ID on the object then create one that's unlikely to duplicate.
			if ( typeof element.id === 'undefined' || element.id === '' ) {
				element.id = getRandomString( 24 );
			}

			// Attach the click event handler to any log out links
			if ( element.dataset.pianoScreen === 'logout' ) {
				element.addEventListener( 'click', function() {
					if ( window.tp.user.isUserValid() ) {
						window.tp.pianoId.logout();
					}
				} );
				continue;
			}

			// For everything else we'll go through a whole process
			switch ( type ) {
				// Inject the TP object into this node
				case 'inline':
					show(
						element,
						element.dataset.pianoScreen,
						typeof element.dataset.pianoArgs !== 'undefined' && JSON.parse( element.dataset.pianoArgs ) // Decode the json encoded object stored on the node.
					);
					break;

				// Show a modal window on click of the object
				case 'modal':
					element.addEventListener( 'click', function( e ) {
						var screen = typeof this.dataset.pianoScreen !== 'undefined' && this.dataset.pianoScreen,
							args   = typeof this.dataset.pianoArgs !== 'undefined' && JSON.parse( this.dataset.pianoArgs ),
							done   = false;

						// Pop up the popup
						createModal( 'tinypass' + screen, function( node ) {
							return (done = show( node, screen, args ));
						} );

						// Prevent any links being followed
						if ( typeof e !== 'undefined' && done ) {
							e.preventDefault();
						}
					} );

					break;

				case 'timer':
					args.time = typeof args.time !== 'undefined' && args.time > 0 ? args.time : 1;

					setTimeout( (function( e, a ) {
						return function() {
							createModal( 'tinypass' + e.dataset.pianoScreen, function( node ) {
								return show( node, e.dataset.pianoScreen, a );
							} );
						};
					}( element, args )), args.time * 1000 );
					break;

				case 'scroll':
					scrollWatch.addElement( element );
					break;
			}
		}
	} ).catch( console.error );

	return {
		createModal: createModal,
		showMyAccount: showMyAccount,
		showRegistration: showRegistration,
		showPasswordRecover: showPasswordRecover,
		showNewPassword: showPasswordRecover,
		showLogin: showLogin,
		showOffer: showOffer,
		show: show,
		getAuthToken: getAuthToken
	};
}());
